<template>
<div class="number-input-outer-wrapper">
  <label :for="id">{{ label }}</label>
  <div class="number-input-inner-wrapper">
    <div class="number-input-button" @click="decrement">-</div>
    <input :id="id" v-model="number" :min="min" :max="max">
    <div class="number-input-button" @click="increment">+</div>
  </div>
</div>
</template>

<script>
import capitalizeFirstLetter from '@/utils/capitalizeFirstLetter';

export default {
  name: 'NumberInput',
  props: ['id', 'label', 'min', 'max'],
  computed: {
    number: {
      get() {
        return this.$store.getters[this.id];
      },
      set(val) {
        this.$store.commit(`set${capitalizeFirstLetter(this.id)}`, val);
      }
    }
  },
  methods: {
    increment() {
      this.number += 1;
    },
    decrement() {
      this.number -= 1;
    }
  }
};
</script>

<style lang='scss' scoped>
.number-input-outer-wrapper {
  display: grid;
  grid-template-rows: 1fr 40px;
  margin: 15px;

  label {
    font-size: 1.1rem;
    margin-bottom: 5px;
  }
}

.number-input-inner-wrapper {
  display: grid;
  grid-template-columns: 30px 1fr 30px;
  width: 180px;
  height: 40px;
}

.number-input-button {
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.2rem;
  background-color: #333;
  cursor: pointer;
  user-select: none;
  transition: background-color 0.25s;

  &:hover {
    background-color: #444;
  }

  &:first-of-type {
    border-radius: 10px 0 0 10px;
  }

  &:last-of-type {
    border-radius: 0 10px 10px 0;
  }
}

input {
  background: #222;
  color: #fff;
  padding: 5px;
  padding-left: 15px;
  border: none;
  text-align: center;
  font-size: 0.9rem;
}
</style>
